import {Component, Input, OnInit} from '@angular/core';
import {SafeHtml} from '@angular/platform-browser';
import {ClaimDto} from "../../../../auto-generated-server-dtos/adjuster/claim/claim-dto";
import {CustomerOnFileDto} from "../../../../auto-generated-server-dtos/adjuster/claim/customer-on-file-dto";
import {DocumentDto} from "../../../../auto-generated-server-dtos/adjuster/claim/files/document-dto";
import {ListDocumentsService} from "./service/list-documents.service";
import Utils from "../../../../helpers/utils";
import {DownloadDocumentService} from "../../../../claim/components/file-upload/services/download-document.service";
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-documents',
    templateUrl: './documents.component.html',
    styleUrl: './documents.component.scss'
})
export class DocumentsComponent implements OnInit {
    @Input() ClaimDto!: ClaimDto;
    @Input() customerOnFile: CustomerOnFileDto | undefined;

    documents: (DocumentDto & { fileIcon?: SafeHtml })[] = [];
    isLoading: boolean = true;

    constructor(
        private listDocumentsService: ListDocumentsService,
        private utils: Utils,
        private downloadDocumentService: DownloadDocumentService,
    ) {
    }

    ngOnInit(): void {
        this.listDocumentsService
            .listDocuments(this.ClaimDto!.claimId)
            .subscribe((documents) => {
                this.documents = documents;
                this.documents.forEach(document => {
                    document.fileIcon = this.utils.getFileTypeIcon(document.fileType);
                });
                this.isLoading = false;
            });
    }

    viewDocument(document: DocumentDto) {
        let windowRef = window.open();
        this.downloadDocumentService.downloadDocument(document.documentId).subscribe({
            next: (response) => {
                let downloadBlob = Utils.openBlobInNewTab(response, document.fileType);
                windowRef!.location = window.URL.createObjectURL(downloadBlob);
            },
        });
    }

    openTooltip(tooltip: NgbTooltip) {
        if (tooltip) {
            tooltip.open()
        }
    }

    closeTooltip(tooltip: NgbTooltip) {
        if (tooltip) {
            tooltip.close();
        }
    }

    protected readonly Utils = Utils;
}
